import styled from 'styled-components'

import COLORS from 'constants/colors'
import FONTS from 'constants/fonts'
import MEDIA from 'constants/media'

// Page Headers
import AboutBgr from 'assets/images/backgrounds/page-headers/about.webp'
import AboutBgrSm from 'assets/images/backgrounds/page-headers/about-small.webp'
import NewsBgr from 'assets/images/backgrounds/page-headers/news.webp'
import NewsBgrSm from 'assets/images/backgrounds/page-headers/news-small.webp'
import PressBgr from 'assets/images/backgrounds/page-headers/press.webp'
import PressBgrSm from 'assets/images/backgrounds/page-headers/press-small.webp'
import TeamBgr from 'assets/images/backgrounds/page-headers/team.webp'
import TeamBgrSm from 'assets/images/backgrounds/page-headers/team-small.webp'
import StoryBgr from 'assets/images/backgrounds/page-headers/our-story.webp'
import StoryBgrSm from 'assets/images/backgrounds/page-headers/our-story-small.webp'
import CareersBgr from 'assets/images/backgrounds/page-headers/careers.webp'
import CareersBgrSm from 'assets/images/backgrounds/page-headers/careers-small.webp'
import LocationsBgr from 'assets/images/backgrounds/page-headers/locations.webp'
import LocationsBgrSm from 'assets/images/backgrounds/page-headers/locations-small.webp'
import LocationBgr from 'assets/images/backgrounds/page-headers/location.webp'
import LocationBgrSm from 'assets/images/backgrounds/page-headers/location-small.webp'
import SupportBgr from 'assets/images/backgrounds/page-headers/support.webp'
import SupportBgrSm from 'assets/images/backgrounds/page-headers/support-small.webp'
import ContactBgr from 'assets/images/backgrounds/page-headers/contact.webp'
import ContactBgrSm from 'assets/images/backgrounds/page-headers/contact-small.webp'
import CarriersBgr from 'assets/images/backgrounds/page-headers/carriers.webp'
import CarriersBgrSm from 'assets/images/backgrounds/page-headers/carriers-small.webp'
import ProductDetailBgr from 'assets/images/backgrounds/page-headers/product-detail.webp'
import ProductDetailBgrSm from 'assets/images/backgrounds/page-headers/product-detail-small.webp'
import ProductListBgr from 'assets/images/backgrounds/page-headers/product-list.webp'
import ProductListBgrSm from 'assets/images/backgrounds/page-headers/product-list-small.webp'
import FranchisingBgr from 'assets/images/backgrounds/page-headers/franchising.webp'
import FranchisingBgrSm from 'assets/images/backgrounds/page-headers/franchising-small.webp'
// Page Headers PLACEHOLDERS
import AboutBgrPlaceholder from 'assets/images/backgrounds/page-headers/about-placeholder.webp'
import AboutBgrSmPlaceholder from 'assets/images/backgrounds/page-headers/about-small-placeholder.webp'
import NewsBgrPlaceholder from 'assets/images/backgrounds/page-headers/news-placeholder.webp'
import NewsBgrSmPlaceholder from 'assets/images/backgrounds/page-headers/news-small-placeholder.webp'
import PressBgrPlaceholder from 'assets/images/backgrounds/page-headers/press-placeholder.webp'
import PressBgrSmPlaceholder from 'assets/images/backgrounds/page-headers/press-small-placeholder.webp'
import TeamBgrPlaceholder from 'assets/images/backgrounds/page-headers/team-placeholder.webp'
import TeamBgrSmPlaceholder from 'assets/images/backgrounds/page-headers/team-small-placeholder.webp'
import StoryBgrPlaceholder from 'assets/images/backgrounds/page-headers/our-story-placeholder.webp'
import StoryBgrSmPlaceholder from 'assets/images/backgrounds/page-headers/our-story-small-placeholder.webp'
import CareersBgrPlaceholder from 'assets/images/backgrounds/page-headers/careers-placeholder.webp'
import CareersBgrSmPlaceholder from 'assets/images/backgrounds/page-headers/careers-small-placeholder.webp'
import LocationsBgrPlaceholder from 'assets/images/backgrounds/page-headers/locations-placeholder.webp'
import LocationsBgrSmPlaceholder from 'assets/images/backgrounds/page-headers/locations-small-placeholder.webp'
import LocationBgrPlaceholder from 'assets/images/backgrounds/page-headers/location-placeholder.webp'
import LocationBgrSmPlaceholder from 'assets/images/backgrounds/page-headers/location-small-placeholder.webp'
import SupportBgrPlaceholder from 'assets/images/backgrounds/page-headers/support-placeholder.webp'
import SupportBgrSmPlaceholder from 'assets/images/backgrounds/page-headers/support-small-placeholder.webp'
import ContactBgrPlaceholder from 'assets/images/backgrounds/page-headers/contact-placeholder.webp'
import ContactBgrSmPlaceholder from 'assets/images/backgrounds/page-headers/contact-small-placeholder.webp'
import CarriersBgrPlaceholder from 'assets/images/backgrounds/page-headers/carriers-placeholder.webp'
import CarriersBgrSmPlaceholder from 'assets/images/backgrounds/page-headers/carriers-small-placeholder.webp'
import ProductDetailBgrPlaceholder from 'assets/images/backgrounds/page-headers/product-detail-placeholder.webp'
import ProductDetailBgrSmPlaceholder from 'assets/images/backgrounds/page-headers/product-detail-small-placeholder.webp'
import ProductListBgrPlaceholder from 'assets/images/backgrounds/page-headers/product-list-placeholder.webp'
import ProductListBgrSmPlaceholder from 'assets/images/backgrounds/page-headers/product-list-small-placeholder.webp'
import FranchisingBgrPlaceholder from 'assets/images/backgrounds/page-headers/franchising-placeholder.webp'
import FranchisingBgrSmPlaceholder from 'assets/images/backgrounds/page-headers/franchising-small-placeholder.webp'

// Page Headers Locations
import LocationBeaverton from 'assets/images/backgrounds/page-headers-locations/beaverton.webp'
import LocationBeavertonSm from 'assets/images/backgrounds/page-headers-locations/beaverton-small.webp'
import LocationEugene from 'assets/images/backgrounds/page-headers-locations/eugene.webp'
import LocationEugeneSm from 'assets/images/backgrounds/page-headers-locations/eugene-small.webp'
import LocationGrantsPass from 'assets/images/backgrounds/page-headers-locations/grantspass.webp'
import LocationGrantsPassSm from 'assets/images/backgrounds/page-headers-locations/grantspass-small.webp'
import LocationLakeOswego from 'assets/images/backgrounds/page-headers-locations/lakeoswego.webp'
import LocationLakeOswegoSm from 'assets/images/backgrounds/page-headers-locations/lakeoswego-small.webp'
import LocationLasVegas from 'assets/images/backgrounds/page-headers-locations/vegas.webp'
import LocationLasVegasSm from 'assets/images/backgrounds/page-headers-locations/vegas-small.webp'
import LocationMedford from 'assets/images/backgrounds/page-headers-locations/medford.webp'
import LocationMedfordSm from 'assets/images/backgrounds/page-headers-locations/medford-small.webp'
import LocationReno from 'assets/images/backgrounds/page-headers-locations/reno.webp'
import LocationRenoSm from 'assets/images/backgrounds/page-headers-locations/reno-small.webp'
// Page Headers Locations PLACEHOLDERS
import LocationBeavertonPlaceholder from 'assets/images/backgrounds/page-headers-locations/beaverton-placeholder.webp'
import LocationBeavertonSmPlaceholder from 'assets/images/backgrounds/page-headers-locations/beaverton-small-placeholder.webp'
import LocationEugenePlaceholder from 'assets/images/backgrounds/page-headers-locations/eugene-placeholder.webp'
import LocationEugeneSmPlaceholder from 'assets/images/backgrounds/page-headers-locations/eugene-small-placeholder.webp'
import LocationGrantsPassPlaceholder from 'assets/images/backgrounds/page-headers-locations/grantspass-placeholder.webp'
import LocationGrantsPassSmPlaceholder from 'assets/images/backgrounds/page-headers-locations/grantspass-small-placeholder.webp'
import LocationLakeOswegoPlaceholder from 'assets/images/backgrounds/page-headers-locations/lakeoswego-placeholder.webp'
import LocationLakeOswegoSmPlaceholder from 'assets/images/backgrounds/page-headers-locations/lakeoswego-small-placeholder.webp'
import LocationMedfordPlaceholder from 'assets/images/backgrounds/page-headers-locations/medford-placeholder.webp'
import LocationMedfordSmPlaceholder from 'assets/images/backgrounds/page-headers-locations/medford-small-placeholder.webp'
import LocationRenoPlaceholder from 'assets/images/backgrounds/page-headers-locations/reno-placeholder.webp'
import LocationRenoSmPlaceholder from 'assets/images/backgrounds/page-headers-locations/reno-small-placeholder.webp'
import LocationLasVegasPlaceholder from 'assets/images/backgrounds/page-headers-locations/vegas-placeholder.webp'
import LocationLasVegasSmPlaceholder from 'assets/images/backgrounds/page-headers-locations/vegas-small-placeholder.webp'

// Page Headers Products
import ProductAuto from 'assets/images/backgrounds/page-headers-products/auto.webp'
import ProductAutoSm from 'assets/images/backgrounds/page-headers-products/auto-small.webp'
import ProductBusiness from 'assets/images/backgrounds/page-headers-products/business.webp'
import ProductBusinessSm from 'assets/images/backgrounds/page-headers-products/business-small.webp'
import ProductDisability from 'assets/images/backgrounds/page-headers-products/disability.webp'
import ProductDisabilitySm from 'assets/images/backgrounds/page-headers-products/disability-small.webp'
import ProductHealth from 'assets/images/backgrounds/page-headers-products/health.webp'
import ProductHealthSm from 'assets/images/backgrounds/page-headers-products/health-small.webp'
import ProductHome from 'assets/images/backgrounds/page-headers-products/home.webp'
import ProductHomeSm from 'assets/images/backgrounds/page-headers-products/home-small.webp'
import ProductLife from 'assets/images/backgrounds/page-headers-products/life.webp'
import ProductLifeSm from 'assets/images/backgrounds/page-headers-products/life-small.webp'
import ProductMedicare from 'assets/images/backgrounds/page-headers-products/medicare.webp'
import ProductMedicareSm from 'assets/images/backgrounds/page-headers-products/medicare-small.webp'
import ProductRetirement from 'assets/images/backgrounds/page-headers-products/retirement.webp'
import ProductRetirementSm from 'assets/images/backgrounds/page-headers-products/retirement-small.webp'
import ProductGroup from 'assets/images/backgrounds/page-headers-products/hero-test.jpg'
import ProductGroupSm from 'assets/images/backgrounds/page-headers-products/hero-test-small.jpg'
import ProductGroupQuote from 'assets/images/backgrounds/page-headers-products/group-quote.webp'
import ProductGroupQuoteSm from 'assets/images/backgrounds/page-headers-products/group-quote-small.jpg'
// Page Headers Products PLACEHOLDERS
import ProductAutoPlaceholder from 'assets/images/backgrounds/page-headers-products/auto-placeholder.webp'
import ProductAutoSmPlaceholder from 'assets/images/backgrounds/page-headers-products/auto-small-placeholder.webp'
import ProductBusinessPlaceholder from 'assets/images/backgrounds/page-headers-products/business-placeholder.webp'
import ProductBusinessSmPlaceholder from 'assets/images/backgrounds/page-headers-products/business-small-placeholder.webp'
import ProductDisabilityPlaceholder from 'assets/images/backgrounds/page-headers-products/disability-placeholder.webp'
import ProductDisabilitySmPlaceholder from 'assets/images/backgrounds/page-headers-products/disability-small-placeholder.webp'
import ProductHealthPlaceholder from 'assets/images/backgrounds/page-headers-products/health-placeholder.webp'
import ProductHealthSmPlaceholder from 'assets/images/backgrounds/page-headers-products/health-small-placeholder.webp'
import ProductHomePlaceholder from 'assets/images/backgrounds/page-headers-products/home-placeholder.webp'
import ProductHomeSmPlaceholder from 'assets/images/backgrounds/page-headers-products/home-small-placeholder.webp'
import ProductLifePlaceholder from 'assets/images/backgrounds/page-headers-products/life-placeholder.webp'
import ProductLifeSmPlaceholder from 'assets/images/backgrounds/page-headers-products/life-small-placeholder.webp'
import ProductMedicarePlaceholder from 'assets/images/backgrounds/page-headers-products/medicare-placeholder.webp'
import ProductMedicareSmPlaceholder from 'assets/images/backgrounds/page-headers-products/medicare-small-placeholder.webp'
import ProductRetirementPlaceholder from 'assets/images/backgrounds/page-headers-products/retirement-placeholder.webp'
import ProductRetirementSmPlaceholder from 'assets/images/backgrounds/page-headers-products/retirement-small-placeholder.webp'
import ProductGroupPlaceholder from 'assets/images/backgrounds/page-headers-products/group-placeholder.webp'
import ProductGroupSmPlaceholder from 'assets/images/backgrounds/page-headers-products/group-small-placeholder.webp'
import ProductGroupQuotePlaceholder from 'assets/images/backgrounds/page-headers-products/group-quote-placeholder.webp'
import ProductGroupQuoteSmPlaceholder from 'assets/images/backgrounds/page-headers-products/group-quote-small-placeholder.webp'

import {
  StylesProps,
  BgPosition,
}from './types'

export const bgImages = {
  About: {
    small: {
      src: AboutBgrSm,
      placeholder: AboutBgrSmPlaceholder,
    },
    medium: {
      src: AboutBgr,
      placeholder: AboutBgrPlaceholder,
    },
  },

  News: {
    small: {
      src: NewsBgrSm,
      placeholder: NewsBgrSmPlaceholder,
    },
    medium: {
      src: NewsBgr,
      placeholder: NewsBgrPlaceholder,
    },
  },

  Press: {
    small: {
      src: PressBgrSm,
      placeholder: PressBgrSmPlaceholder,
    },
    medium: {
      src: PressBgr,
      placeholder: PressBgrPlaceholder,
    },
  },

  Team: {
    small: {
      src: TeamBgrSm,
      placeholder: TeamBgrSmPlaceholder,
    },
    medium: {
      src: TeamBgr,
      placeholder: TeamBgrPlaceholder,
    },
  },

  Story: {
    small: {
      src: StoryBgrSm,
      placeholder: StoryBgrSmPlaceholder,
      bgPosition: BgPosition.center,
    },
    medium: {
      src: StoryBgr,
      placeholder: StoryBgrPlaceholder,
      bgPosition: BgPosition.center,
    },
  },

  Careers: {
    small: {
      src: CareersBgrSm,
      placeholder: CareersBgrSmPlaceholder,
    },
    medium: {
      src: CareersBgr,
      placeholder: CareersBgrPlaceholder,
    },
  },

  Locations: {
    small: {
      src: LocationsBgrSm,
      placeholder: LocationsBgrSmPlaceholder,
      bgPosition: BgPosition.center,
    },
    medium: {
      src: LocationsBgr,
      placeholder: LocationsBgrPlaceholder,
      bgPosition: BgPosition.center,
    },
  },

  Location: {
    small: {
      src: LocationBgrSm,
      placeholder: LocationBgrSmPlaceholder,
    },
    medium: {
      src: LocationBgr,
      placeholder: LocationBgrPlaceholder,
    },
  },

  Support: {
    small: {
      src: SupportBgrSm,
      placeholder: SupportBgrSmPlaceholder,
    },
    medium: {
      src: SupportBgr,
      placeholder: SupportBgrPlaceholder,
    },
  },

  Contact: {
    small: {
      src: ContactBgrSm,
      placeholder: ContactBgrSmPlaceholder,
    },
    medium: {
      src: ContactBgr,
      placeholder: ContactBgrPlaceholder,
    },
  },

  Carriers: {
    small: {
      src: CarriersBgrSm,
      placeholder: CarriersBgrSmPlaceholder,
    },
    medium: {
      src: CarriersBgr,
      placeholder: CarriersBgrPlaceholder,
    },
  },

  Productlist: {
    small: {
      src: ProductListBgrSm,
      placeholder: ProductListBgrSmPlaceholder,
    },
    medium: {
      src: ProductListBgr,
      placeholder: ProductListBgrPlaceholder,
    },
  },

  Productdetail: {
    small: {
      src: ProductDetailBgrSm,
      placeholder: ProductDetailBgrSmPlaceholder,
    },
    medium: {
      src: ProductDetailBgr,
      placeholder: ProductDetailBgrPlaceholder,
    },
  },

  Franchising: {
    small: {
      src: FranchisingBgrSm,
      placeholder: FranchisingBgrSmPlaceholder,
      bgPosition: BgPosition.center,
    },
    medium: {
      src: FranchisingBgr,
      placeholder: FranchisingBgrPlaceholder,
      bgPosition: BgPosition.center,
    },
  },
  // Retail Lounge Bgrs

  Beaverton: {
    small: {
      src: LocationBeavertonSm,
      placeholder: LocationBeavertonSmPlaceholder,
      bgPosition: BgPosition.center,
    },
    medium: {
      src: LocationBeaverton,
      placeholder: LocationBeavertonPlaceholder,
      bgPosition: BgPosition.center,
    },
  },

  Eugene: {
    small: {
      src: LocationEugeneSm,
      placeholder: LocationEugeneSmPlaceholder,
      bgPosition: BgPosition.center,
    },
    medium: {
      src: LocationEugene,
      placeholder: LocationEugenePlaceholder,
      bgPosition: BgPosition.center,
    },
  },

  GrantsPass: {
    small: {
      src: LocationGrantsPassSm,
      placeholder: LocationGrantsPassSmPlaceholder,
    },
    medium: {
      src: LocationGrantsPass,
      placeholder: LocationGrantsPassPlaceholder,
    },
  },

  LakeOswego: {
    small: {
      src: LocationLakeOswegoSm,
      placeholder: LocationLakeOswegoSmPlaceholder,
    },
    medium: {
      src: LocationLakeOswego,
      placeholder: LocationLakeOswegoPlaceholder,
    },
  },

  LasVegas: {
    small: {
      src: LocationLasVegasSm,
      placeholder: LocationLasVegasSmPlaceholder,
    },
    medium: {
      src: LocationLasVegas,
      placeholder: LocationLasVegasPlaceholder,
    },
  },

  Medford: {
    small: {
      src: LocationMedfordSm,
      placeholder: LocationMedfordSmPlaceholder,
      bgPosition: BgPosition.center,
    },
    medium: {
      src: LocationMedford,
      placeholder: LocationMedfordPlaceholder,
      bgPosition: BgPosition.center,
    },
  },

  Reno: {
    small: {
      src: LocationRenoSm,
      placeholder: LocationRenoSmPlaceholder,
    },
    medium: {
      src: LocationReno,
      placeholder: LocationRenoPlaceholder,
    },
  },

  // Product Bgrs

  Group: {
    small: {
      src: ProductGroupSm,
      placeholder: ProductGroupSmPlaceholder,
      bgPosition: BgPosition.center,
    },
    medium: {
      src: ProductGroup,
      placeholder: ProductGroupPlaceholder,
      bgPosition: BgPosition.topRight,
    },
  },

  GroupQuote: {
    small: {
      src: ProductGroupQuoteSm,
      placeholder: ProductGroupQuoteSmPlaceholder,
      bgPosition: BgPosition.center,
    },
    medium: {
      src: ProductGroupQuote,
      placeholder: ProductGroupQuotePlaceholder,
      bgPosition: BgPosition.center,
    },
  },

  Retirement: {
    small: {
      src: ProductRetirementSm,
      placeholder: ProductRetirementSmPlaceholder,
    },
    medium: {
      src: ProductRetirement,
      placeholder: ProductRetirementPlaceholder,
    },
  },

  Medicare: {
    small: {
      src: ProductMedicareSm,
      placeholder: ProductMedicareSmPlaceholder,
    },
    medium: {
      src: ProductMedicare,
      placeholder: ProductMedicarePlaceholder,
    },
  },

  Life: {
    small: {
      src: ProductLifeSm,
      placeholder: ProductLifeSmPlaceholder,
    },
    medium: {
      src: ProductLife,
      placeholder: ProductLifePlaceholder,
    },
  },

  Home: {
    small: {
      src: ProductHomeSm,
      placeholder: ProductHomeSmPlaceholder,
    },
    medium: {
      src: ProductHome,
      placeholder: ProductHomePlaceholder,
    },
  },

  Health: {
    small: {
      src: ProductHealthSm,
      placeholder: ProductHealthSmPlaceholder,
    },
    medium: {
      src: ProductHealth,
      placeholder: ProductHealthPlaceholder,
    },
  },

  Disability: {
    small: {
      src: ProductDisabilitySm,
      placeholder: ProductDisabilitySmPlaceholder,
    },
    medium: {
      src: ProductDisability,
      placeholder: ProductDisabilityPlaceholder,
    },
  },

  Auto: {
    small: {
      src: ProductAutoSm,
      placeholder: ProductAutoSmPlaceholder,
    },
    medium: {
      src: ProductAuto,
      placeholder: ProductAutoPlaceholder,
    },
  },

  Business: {
    small: {
      src: ProductBusinessSm,
      placeholder: ProductBusinessSmPlaceholder,
    },
    medium: {
      src: ProductBusiness,
      placeholder: ProductBusinessPlaceholder,
    },
  },
}

export const NoImage = styled.div`
  h1 {
    max-width: 800px;
    padding-top: 200px;
    text-align: center;
  }
`

export const ContentWrap = styled.div`
  background-color: ${(props: StylesProps): string => (props.hasOpacity ? 'rgba(255, 255, 255, 0.5)' : 'transparent')};
  padding: 0 2rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  ${MEDIA.medium`
    padding: 0 20px 4rem;
  `}
`

export const CallToAction = styled.div`
  margin-top: 20px;
  text-align: center;
`

export const CallToActionTitle = styled.h2`
  font-size: 1.6rem;
  margin-top: 0;
  color: ${COLORS.BLUE};
  ${MEDIA.medium`
    font-size: 2rem;
  `}
`

export default styled.div<StylesProps>`
  background-image: url(${(props: StylesProps): string => props.bgImage || ''});
  background-position: ${(props: StylesProps): string => props.bgPosition || (props.right ? BgPosition.right : BgPosition.left)};
  background-size: cover;
  min-height: ${(props: StylesProps): string => (props.isLargeHeight ? '640px' : '500px')};
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h1 {
    margin-top: 50px;
    max-width: 800px;
    width: 100%;
    text-align: center;
  }
  ${MEDIA.medium`
    background-position: ${(props: StylesProps): string => props.bgPosition || 'center center'};
    min-height: ${(props: StylesProps): string => (props.isLargeHeight ? '1000px' : '590px')};
  `}
  ${(props: StylesProps): string => (props.isLoading && 'filter: blur(10px);') || ''}
  transition: all 0.5s linear;
`

export const LargeTitle = styled.h1`
  color: ${COLORS.BLUE};
  display: block;
  font-size: 40px;
  margin-bottom: 0;
  margin-top: 1rem !important;
  font-weight: ${FONTS.WEIGHTDEMI};
  ${MEDIA.medium`
    font-size: 60px;
    margin-top: 4rem!important;
  `}
`
